import { render, staticRenderFns } from "./newsletter.component.vue?vue&type=template&id=03b65e07&"
import script from "./newsletter.component.vue?vue&type=script&lang=ts&"
export * from "./newsletter.component.vue?vue&type=script&lang=ts&"
import style0 from "./newsletter.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "newsletter.component.vue"
export default component.exports